module.exports = __webpack_public_path__ + "static/media/interviewQuestionTemplate.6b6decb8.xlsx";